import script from "./AppWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./AppWrapper.vue?vue&type=script&setup=true&lang=js"

import "./AppWrapper.vue?vue&type=style&index=0&id=25a7b40f&lang=scss"

const __exports__ = script;

export default __exports__